export default __webpack_public_path__ + "b31962c0371a3a17f4e01f3dd17b5570.png";